<template>
  <!-- 短信记录 -->
  <div class="smsRecord">
    <input-form style="marginTop:20px;" :inputData="inputData" @toParentVal="searchFormMethod" ref="form"></input-form>
    <!-- 表格体 -->
    <div class="content">
      <!-- 表格 -->
      <el-table :data="tableData" v-loading="talbeLoading" style="width: 100%; marginTop: 20px;" :header-cell-style="{ background: '#FAFAFA' }">
        <template slot="empty">
          <div>
            <img src="@/assets/images/default/暂无任何数据.png" />
            <span style="margin-left: -140px">暂无任何数据</span>
          </div>
        </template>
        <el-table-column prop="desensitizePin" label="买家账号" width="170"></el-table-column>
        <el-table-column prop="mobile" label="手机号码" width="170">
          <template slot-scope="scope">
            {{ scope.row.mobile || "--" }}
          </template>
        </el-table-column>
        <el-table-column prop="orderId" label="订单号" width="170"></el-table-column>

        <el-table-column prop="sendContent" label="短信内容" width="500">
          <template slot="header" slot-scope="scope">
            <span>短信内容</span> &nbsp;
            <span class="open" v-show="!tableOpenAll" @click="tableOpenAll = true">展开全部</span>
            <span class="stop" v-show="tableOpenAll" @click="tableOpenAll = false">收起全部</span>
          </template>
          <template slot-scope="scope">
            <el-tooltip class="tooltip" effect="light" :content="scope.row.sendContent" placement="top">
              <div class="hoveTitle" v-show="!tableOpenAll">{{ scope.row.sendContent }}</div>
            </el-tooltip>
            <div class="hoveTitleShowMore" v-show="tableOpenAll">{{ scope.row.sendContent }}</div>
          </template>
        </el-table-column>

        <!-- 占位 -->
        <el-table-column width="20"></el-table-column>

        <el-table-column prop="warning" label="提醒类型" width="140"></el-table-column>
        <el-table-column prop="smsNumber" label="实际扣费（条）" width="140"></el-table-column>

        <el-table-column label="发送状态" width="150">
          <template slot-scope="scope">
            {{ scope.row.status == 1 ? "已发送" : "黑名单失败" }}
          </template>
        </el-table-column>

        <el-table-column prop="sendTime" label="发送时间"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import inputForm from "@/components/inputForm";
import { querySmsList } from "@/api/serviceCenter/refundWaring";

export default {
  components: {
    inputForm,
  },
  data() {
    return {
      // 表单传值项
      inputData: [
        {
          name: "发送时间:",
          myDate: true,
          val: ["sendStartTime", "sendEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
        {
          name: "发送状态:",
          val: "status",
          selectArr: [
            { label: "全部", id: "" },
            { label: "发送成功", id: 1 },
            { label: "发送失败", id: 2 },
          ],
        },
        {
          name: "买家昵称:",
          val: "pin",
          placeholder: "请输入买家昵称",
        },
        {
          name: "手机号:",
          val: "mobile",
          placeholder: "请输入手机号",
        },
        {
          name: "订单编号:",
          val: "orderId",
          placeholder: "请输入订单编号",
        },
        {
          name: "短信内容:",
          val: "sendContent",
          placeholder: "请输入短信内容",
        },
      ],
      talbeLoading: false, // 控制表格loading状态
      tableData: [], // 表格数据
      tableOpenAll: false, // 回评内容展开
      size: 20,
      current: 1,
      total: 0,
    };
  },
  mounted() {
    this.$refs.form.submitForm("formSearch");
  },
  methods: {
    /**
     * 表单查询
     */
    searchFormMethod(params) {
      params.size = this.size;
      params.current = this.current;
      params.comfrom = "退款预警";
      this.getSmsList(params);
    },
    /**
     * 获取短信记录列表
     */
    getSmsList(params) {
      this.talbeLoading = true;
      querySmsList(params)
        .then((res) => {
          this.talbeLoading = false;
          this.tableData = res && res.data.records;
          this.total = res && +res.data.total;
        })
        .catch((err) => (this.talbeLoading = false));
    },
    /**
     * 分页变化
     */
    handleSizeChange(val) {
      this.current = 1;
      this.size = val;
      this.$refs.form.submitForm("formSearch");
    },
    handleCurrentChange(val) {
      this.current = val;
      this.$refs.form.submitForm("formSearch");
    },
  },
};
</script>

<style lang="scss" scoped>
.smsRecord {
  .content {
    box-sizing: border-box;
    padding: 0 28px 30px;
    .open,
    .stop {
      color: #fe4d45;
      font-weight: 400;
      cursor: pointer;
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>
